import "./dark/dark.css"
import "./light/light.css"
import {getQueryVariable} from '@/utils/comment'
let theme = getQueryVariable('theme');
if (theme) {
    document.documentElement.setAttribute("theme", theme)
} else {
    document.documentElement.setAttribute("theme", "light")
}



// WEBPACK FOOTER //
// ./src/assets/theme/theme.js